import request from '@/utils/request'

let Inspection_threeApi = {

  /*一日三检记录列表*/
  list(data) {
    return request._post('/shop/plus.inspection_three.Index/index', data);
},
/*添加一日三检记录*/
add(data) {
    return request._post('/shop/plus.inspection_three.Index/add', data);
},
/*修改一日三检记录*/
edit(data) {
    return request._post('/shop/plus.inspection_three.Index/edit', data);
},
/*删除一日三检记录*/
del(data) {
    return request._post('/shop/plus.inspection_three.Index/del', data);
},
/*一日三检记录详情*/
detail(data) {
  return request._post('/shop/plus.inspection_three.Index/detail', data);
},
saveSetting(data, errorback) {
    return request._post('/shop/plus.inspection_three.Setting/getSetting', data, errorback);
},
getSetting(data, errorback) {
    return request._get('/shop/plus.inspection_three.Setting/getSetting', data, errorback);
},
importData(data) {
    return request._post('/shop/plus.inspection_three.Index/import', data);
},
}
export default Inspection_threeApi;



// WEBPACK FOOTER //
// ./src/api/inspection_three.js